import React from "react";
import {
    Row,
    Col,
    Input,
    Button,
    Space,
    Modal,
    Image,
    Tooltip,
    Drawer,
    message,
    Form,
    Select,
    Checkbox
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";

import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import StudentStore from "../store/StudentStore";
import { Link } from "react-router-dom";
import deleteVehicleIcon from "../assets/images/NewDesign/delete-vehicle.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import uploadIcon from "../assets/images/NewDesign/upload.svg";
import sampleDownloadIcon from "../assets/images/NewDesign/SampleDownload.svg";
import sampleUploadIcon from "../assets/images/NewDesign/SampleUpload.svg";
import UploadTitleIcon from "../assets/images/NewDesign/UploadTitle.svg";
import uploadOutlined from "../assets/images/NewDesign/uploadOutlined.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import StudentAdd from "./StudentAdd";
import CompanyStore from "../store/CompanyStore";
import Dragger from "antd/es/upload/Dragger";
import axios from "axios";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "universal-cookie";
import PassengerStore from "../store/PassengerStore";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import VehicleStore from "../store/VehicleStore";
const { Option } = Select;

class StudentList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.companyStore = new CompanyStore(this);
        this.studentStore = new StudentStore(this);
        this.passengerStore = new PassengerStore();
        this.vehicleStore = new VehicleStore();
        this.cookies = new Cookies();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            openConfirm: false,
            confirmLoading: false,
            loadList: 0,
            showStudReg: false,
            update: 0,
            listDataUpdate: false,
            openDeleteModal: false,
            selectedStudents: [],
            subscribe: 0,
            isBusAssign: '',
            SortStudentBy: '',

        };
        this.columns = [
            {
                title: "Name",
                dataIndex: "spName",
                width: 20,
                ellipsis: true,
                render: (value, record) => {
                    return (
                        <Tooltip placement="topLeft" title={value}>
                            <Link
                                style={{ color: "#2563EB", textDecoration: "none" }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    // console.log("**********editRecord****************")
                                    console.log(record)
                                    // this.props.canUpdate("simlist") && 
                                    this.onEdit(record);
                                }}
                            >
                                {value}
                            </Link>
                        </Tooltip>
                    );
                }
            },
            {
                title: "ID",
                dataIndex: "idNo    ",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Grade",
                dataIndex: "className",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Div",
                dataIndex: "classDiv",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Term",
                dataIndex: "term",
                width: 15,
                ellipsis: true,
                render: (value) => {
                    if (!value) return "";

                    const termMap = {
                        'All': "All",
                        1: "First",
                        2: "Second",
                        3: "Third",
                    };

                    return value
                        .split(",")
                        .map((id) => ` ${termMap[id] || id}`)
                        .join(", ");
                },
            },
            {
                title: "Service",
                dataIndex: "service",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Tag ID",
                dataIndex: "tagId",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Pickup Point",
                dataIndex: "pickUpPoint",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Pickup Area",
                dataIndex: "pickUpAreaName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Pickup Trip",
                dataIndex: "pTripName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Pickup Bus",
                dataIndex: "pickupVehicleNo",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Pickup Route",
                dataIndex: "pRouteName",
                width: 15,
                ellipsis: true,

            },
            {
                title: "Dropoff Point",
                dataIndex: "dropPoint",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Dropoff Area",
                dataIndex: "dropOffAreaName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Dropoff Trip",
                dataIndex: "dTripName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Dropoff Bus",
                dataIndex: 'DropVehicleNo',
                width: 15,
                ellipsis: true,
            },
            {
                title: "Dropoff Route",
                dataIndex: "dRouteName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Transport Type",
                dataIndex: "transportationType",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Father Name",
                dataIndex: "fatherName",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Contact No",
                dataIndex: "mobileNo",
                width: 15,
                ellipsis: true,
            },
            {
                title: "Subscribe",
                dataIndex: "subscribe",
                width: 15,
                ellipsis: true,
            },
            {
                title: context.translate("_ACTION_"),
                dataIndex: "Action",
                key: "Action",
                // fixed: 'right',
                width: 10,
                align: "center",
                ellipsis: {
                    showTitle: true,
                },
                render: (_, record) => {
                    return (
                        <>
                            <Space>

                                <Tooltip title={this.context.translate('_FLEET_COMPANY_COMPANYLIST_EDIT_')}>
                                    {/* {this.props.canUpdate('vehicledistancelist') &&  */}

                                    <Image

                                        style={{
                                            height: "19px",
                                            width: "15px",
                                            borderRadius: "0px",
                                            cursor: "pointer",
                                        }}
                                        src={editIcon}
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            await this.onEdit(record);
                                        }}

                                    ></Image>
                                    {/* } */}


                                </Tooltip>
                                {/* <Tooltip title={this.context.translate('_FLEET_COMPANY_COMPANYLIST_DELETE_')}>
                                    <Image
                                        src={require("../assets/images/NewDesign/Delete.png")}
                                        style={{ cursor: "pointer", width: '15px' }}
                                        onClick={() =>
                                            this.setState({
                                                openDeleteModal: true,
                                                deleteData: record,
                                            })
                                        }

                                    ></Image>
                                   


                                </Tooltip> */}

                            </Space>
                        </>
                    );
                },
            },

        ];
        this.formRef = React.createRef();
    }
    onEdit = async (record) => {
        console.log("edit record company", record.companyId)
        // const passengerId = record.passengerId;
        await this.context.viewStateStore.setStudentDetails({
            companyId: record.companyId,
        });
        await this.setState({ passengerId: record.passengerId, showStudReg: true });
    };
    async componentDidUpdate(prevProps, prevState) {

        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            // debugger
            const beforeEditCompanyId =
                this.context.viewStateStore.studentDetailsObject.companyId;
            if (beforeEditCompanyId !== "") {
                await this.studentStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    searchField: this.state.searchField,
                    companyId: this.state.companyId,
                });
                const singleData = await this.companyStore.getCompanyDataById(
                    this.context.viewStateStore.studentDetailsObject.companyId
                );
                await this.setState({ company_value_label: singleData });
                this.setState({ listDataUpdate: false });
            }
        }
    }
    async componentDidMount() {
        console.log(base64_decode(this.cookies.get("data")))
        let tokendata = this.cookies.get("data")
            ? JSON.parse(base64_decode(this.cookies.get("data")))
            : "";
        const userToken = tokendata.userToken;

        this.setState({ token: userToken });
        console.log(this.props.getUserData().isadmin)
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            console.log(this.props.getUserData().userCompanyId);
            await this.vehicleStore.getVehiclesCompanyId(this.props.getUserData().userCompanyId);
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.studentStore.loadData({
                offset: 0,
                limit: this.state.pageSize,
                searchField: this.state.searchField,
                companyId: this.props.getUserData().userCompanyId,
            });
        }

        // console.log("object", await this.studentStore?.StudentListArray)
        await this.setState({ pageSize: 50 });

        this.setState({ update: 1 });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleChange(comp) {
        console.log(comp);
        await this.setState({ companyId: comp.value, loadList: 1 });

        const singleData = await this.companyStore.getCompanyDataById(
            comp.value,
            this.isadmin
        );
        console.log(singleData);
        await this.setState({ company_value_label: singleData });
        console.log(this.state.company_value_label);

        await this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        console.log("object", this.state.subscribe);
        await this.studentStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            searchField: this.state.searchField,
            companyId: this.state.companyId,
            subscribe: this.state.subscribe,
            isBusAssign: this.state.isBusAssign
        });
        await this.setState({ loadList: 0 });
    }
    closeModal = () => {
        this.setState({ showStudReg: false, passengerId: null });
    };
    refreshList = async () => {
        this.setState({ loading: true });
        await this.studentStore.loadData({
            companyId: this.state.companyId,
            offset: 0,
            limit: 50,
            searchField: "",
        });
        this.setState({ loading: false, searchField: "", currentPage: 1 });
    };
    responseMsg = async (resp) => {
        console.log(resp.data.companyId);

        if (resp.success == "S") {
            this.setState({ companyId: resp.data.companyId });
            message.success(resp.message);
            await this.refreshList();
            await this.setState({ listDataUpdate: true });
            await this.setState({ showStudReg: false });
        } else {
            message.error(resp.message);
        }
    };
    onDelete = async () => {
        const response = await this.studentStore.deleteRecord(
            this.state.selectedStudents
        );
        //  console.log(response.data.success)
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.setState({ openDeleteModal: false });
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }
    validateFile = (file) => {
        this.setState({ fileList: file });

        const maxSize = config.UploadExcelSize;
        if (file.size > maxSize) {
            message.error("File size must be less than or equal to 1MB");
            return false;
        }
        return true;
    };
    getUploadData = async (fileUp) => {
        let fileinfo = fileUp.file.response;

        if (fileinfo?.success == "S") {
            await this.setState({ excelFile: fileinfo.data });
        }

        this.setState({ update: 1 });
    };

    uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
        try {
            const formData = new FormData();
            formData.append("excelFile", file);
            formData.append("fileType", "passengerimport");
            formData.append("fieldName", "excelFile");

            console.log(this.state.token, "token");
            const response = await axios.post(
                // config.baseURL + this.companyStore.fileUploadUrl,
                config.NodeUrl + "/passenger/uploadExcel",
                formData,
                {
                    headers: {
                        token: this.state.token,
                        "Content-Type": "multipart/form-data",
                    },
                    onUploadProgress: (event) => {
                        const percent = Math.round((event.loaded * 100) / event.total);
                        onProgress({ percent });
                    },
                }
            );

            onSuccess(response.data);
        } catch (error) {
            onError(error);
        }
    };
    onExcelSubmit = async (fieldsValue) => {
        const data = {
            ...fieldsValue,
            companyId: this.state.companyId,
            excelFile: this.state.excelFile,
        };

        if (data.excelFile) {
            const resp = await this.passengerStore.addStudentByExcel(data);

            if (resp?.success == "S") {
                message.success(resp.message);
                this.setState({ excelFile: "" });
            } else {
                message.error(resp.errors[0].error);
            }
            if (resp.message) {
                this.setState({ showUpload: false });
                this.formRef.current?.resetFields();
            }
        } else {
            message.error("Please Upload Excel File");
        }
    };
    searchInput = async (e) => {
        const value = e.target.value;
        console.log("values", value)
        if (value.length > 2 || value.length === 0) {

            await this.studentStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                searchField: value,

            });
            await this.setState({ loadList: 0 });
        }
    };
    render() {
        const companyInputBox = this.state.companyFieldHighlight
            ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
            : { width: "150px" };
        return (
            <>

                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={(value) => this.handleChange(value)}
                                    value={
                                        this.state.company_value_label
                                            ? this.state.company_value_label
                                            : null
                                    }
                                    style={companyInputBox}
                                />
                                <Input
                                    value={this.state.searchField ? this.state.searchField : ""}
                                    placeholder={this.context.translate(
                                        "_SEARCH_BY_STUDENT_NAME_OR_STUDENT_TAGID_"
                                    )}
                                    style={{ width: 300, borderRadius: "25px" }}
                                    onKeyUp={(e) => this.searchInput(e)}
                                    onChange={(e) => {
                                        this.setState({ searchField: e.target.value });
                                    }}
                                />

                                <Select
                                    className="searchInput"
                                    style={{ width: 130 }}
                                    // placeholder='Filter by'
                                    // status={this.state.filterNotSelected ? "error" : false}
                                    placeholder={this.context.translate("_SUBSCRIPTION_")}
                                    onChange={async (val) => {
                                        await this.setState({ subscribe: val });
                                        await this.handleSearch();
                                    }}
                                >
                                    <Select.Option value={0}>
                                        {this.context.translate(
                                            "_ALL_"
                                        )}
                                    </Select.Option>
                                    <Select.Option value={1}>
                                        {this.context.translate(
                                            "_SUBSCRIBED_STUDENTS_"
                                        )}
                                    </Select.Option>

                                    <Select.Option value={2}>
                                        {this.context.translate(
                                            "_UNSUBSCRIBED_STUDENTS_"
                                        )}
                                    </Select.Option>
                                </Select>
                                <Select
                                    className="searchInput"
                                    style={{ width: 210 }}

                                    placeholder={this.context.translate("_IS_ASSIGN_BUS_")}
                                    onChange={async (val) => {
                                        await this.setState({ isBusAssign: val });
                                        await this.handleSearch();
                                    }}
                                    allowClear
                                >

                                    <Select.Option value={1}>
                                        Pickup Bus (Assigned)
                                    </Select.Option>

                                    <Select.Option value={2}>
                                        Pickup Bus (Unassigned)
                                    </Select.Option>
                                    <Select.Option value={3}>
                                        Drop Bus (Assigned)
                                    </Select.Option>

                                    <Select.Option value={4}>
                                        Drop Bus (Unassigned)
                                    </Select.Option>

                                </Select>
                                {/* <Button
                                    icon={<SearchOutlined />}
                                    type="primary"
                                    onClick={() => {
                                        this.searchInputButton();
                                    }}
                                /> */}
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={8}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginInlineEnd: "20px",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                <Tooltip
                                    title={this.context.translate("_UPLOAD_")}
                                    placement="bottom"
                                >
                                    <Button
                                        className="uploadExcelButton"
                                        onClick={() => this.setState({ showUpload: true })}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                cursor: "pointer",
                                                marginInlineEnd: "20px",
                                            }}
                                            src={uploadIcon}
                                        />
                                    </Button>
                                </Tooltip>
                                <Tooltip title={this.context.translate("_DELETE_")} placement="bottom">
                                    <Image
                                        style={{
                                            height: 18,
                                            alignItems: "center",
                                            cursor: "pointer",
                                            marginInlineEnd: "20px",
                                        }}
                                        src={deleteVehicleIcon}
                                        onClick={() => this.setState({ openDeleteModal: true })}
                                    ></Image>
                                </Tooltip>
                                {/* {this.props.canCreate("newMaintenanceList") && ( */}
                                <Button
                                    className="addButtonClass"
                                    onClick={() =>
                                        this.setState({
                                            showStudReg: true,
                                            passengerId: "",
                                        })
                                    }
                                >
                                    <Image
                                        style={{ marginInlineEnd: "5px", width: 13 }}
                                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                    ></Image>
                                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                                </Button>
                                {/* )} */}
                            </Space>
                        </Col>
                    </Row>

                    <ListTable
                        rowSelection={{
                            columnWidth: 10,
                            preserveSelectedRowKeys: true,
                            selectedRowKeys: Array.isArray(this.state.selectedStudents)
                                ? this.state.selectedStudents
                                : [],
                            onChange: async (selectedRowKeys, selectedRows) => {
                                await this.setState({ selectedStudents: selectedRowKeys });
                            },
                        }}
                        rowKey="passengerId"
                        current={this.state.currentPage}
                        total={this.studentStore?.total}
                        columns={this.columns}
                        dataSource={this.studentStore?.StudentListArray}
                        loading={this.studentStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>


                {this.state.showStudReg &&
                    <Drawer
                        className="accountFormDrawer"
                        width={716}
                        closeIcon={false}
                        open={this.state.showStudReg}
                        placement={
                            this.context.locale.language === "english" ? "right" : "left"
                        }
                        footer={false}

                        maskClosable={false}
                        onOk={() => this.setState({ showStudReg: false })}
                        onCancel={() =>
                            this.setState({ showStudReg: false, passengerId: "" })
                        }
                    >
                        <div
                            style={{
                                height: "98%",
                            }}
                        >
                            <StudentAdd
                                passengerId={this.state.passengerId}
                                closeModal={this.closeModal}
                                response={this.responseMsg}
                            />
                        </div>
                    </Drawer>
                }
                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={
                            this.state.selectedStudents.length !== 0 &&
                            this.state.openDeleteModal
                        }
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}

                {this.state.showUpload && (
                    <>
                        <Drawer
                            className="uploadExcelDrawer"
                            width={716}
                            closeIcon={false}
                            open={this.state.showUpload}
                            placement={
                                this.context.locale.language === "english" ? "right" : "left"
                            }
                            footer={false}
                            title={
                                <div className="uploadExcelTitle">
                                    <Image
                                        style={{ height: "60px" }}
                                        src={UploadTitleIcon}
                                    ></Image>
                                    <span>
                                        {" "}
                                        {this.context.translate("_UPLOAD_EXCEL_TITLE_")}
                                    </span>
                                </div>
                            }
                            maskClosable={false}
                            onOk={() => this.setState({ showUpload: false })}
                            onCancel={() =>
                                this.setState({
                                    showUpload: false,
                                    excelFile: "",
                                })
                            }
                        >
                            <Form
                                name="excelimport"
                                layout="vertical"
                                onFinish={this.onExcelSubmit}
                                style={{ margin: "16px 0px" }}
                            >
                                {(this.props.getUserData().isadmin === -1 ||
                                    this.props.getUserData().isadmin === 3) && (
                                        <Form.Item
                                            name="companyId"
                                            className="uploadCompany"
                                            label={
                                                <span>
                                                    {this.context.translate("_ACCOUNT_")}{" "}
                                                    <span style={{ color: "red" }}>*</span>
                                                </span>
                                            }
                                            rules={[{ required: true }]}
                                            required={false}
                                        >
                                            <CompanyAutocomplete
                                                onChange={(companyId) => {
                                                    this.setState({ companyId: companyId.value });
                                                }}
                                            />
                                        </Form.Item>
                                    )}
                                <Dragger
                                    onRemove={() =>
                                        this.setState({ excelFile: "", fileList: [] })
                                    }
                                    name="excelFile"
                                    // action={
                                    //   // config.baseURL + "/index.php?c=company&a=fileupload"
                                    //   config.baseURL + this.driversStore.uploadExcelUrl
                                    // }
                                    listType="text"
                                    // data={{
                                    //   fileType: "accountimport",
                                    //   fieldName: "excelFile",
                                    // }}
                                    customRequest={(options) => this.uploadFunction(options)}
                                    onChange={this.getUploadData}
                                    beforeUpload={(file) => this.validateFile(file)}
                                    maxCount={1}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: "20px",
                                        }}
                                    >
                                        <div>
                                            <Image
                                                style={{ width: "90px" }}
                                                src={uploadOutlined}
                                            ></Image>
                                        </div>
                                        <div className="uploadFileText">
                                            <span>
                                                {this.context.translate("_UPLOAD_EXCEL_FILE_")}
                                            </span>
                                            <p>
                                                {this.context.translate("_UPLOAD_TEXT_")}{" "}
                                                <span
                                                    style={{
                                                        color: "var(--Blue-6, #1890FF)",
                                                        fontSize: "14px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {this.context.translate("_UPLOAD_TEXT_1_")}{" "}
                                                </span>
                                                {this.context.translate("_UPLOAD_TEXT_2_")}
                                            </p>
                                        </div>
                                    </div>
                                </Dragger>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        textAlign: "center",
                                        marginTop: "16px",
                                    }}
                                >
                                    <div className="sampleDownload">
                                        <span>
                                            {" "}
                                            {this.context.translate("_SAMPLE_DOWNLOAD_")}
                                        </span>
                                        <p>{this.context.translate("_SAMPLE_EXCEL_DESC_")}</p>
                                        <Button onClick={() => this.studentStore.sampleExcel()}>
                                            <Image src={sampleDownloadIcon}></Image>
                                            <span style={{ color: "#2563EB", fontSize: "14px" }}>
                                                {" "}
                                                {this.context.translate("_SAMPLE_DOWNLOAD_")}
                                            </span>
                                        </Button>
                                    </div>

                                    <div className="sampleUpload">
                                        <span> {this.context.translate("_SAMPLE_UPLOAD_")}</span>
                                        <p>{this.context.translate("_SAMPLE_DOWNLOAD_DESC_")}</p>
                                        <Button>
                                            <Image src={sampleUploadIcon}></Image>
                                            <span style={{ color: "#2563EB", fontSize: "14px" }}>
                                                {this.context.translate("_SAMPLE_UPLOAD_")}
                                            </span>{" "}
                                        </Button>
                                    </div>
                                </div>

                                <Space className="uploadFooter">
                                    <Button
                                        className="uploadCancelButton"
                                        onClick={() =>
                                            this.setState({
                                                showUpload: false,
                                                excelFile: "",
                                            })
                                        }
                                    >
                                        {this.context.translate(
                                            "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                        )}
                                    </Button>
                                    <Button
                                        htmlType="submit"
                                        className="uploadButton"
                                    // onClick={() => this.onExcelSubmit()}
                                    >
                                        {this.context.translate("_UPLOAD_")}
                                    </Button>
                                </Space>
                            </Form>
                        </Drawer>{" "}
                    </>
                )}

            </>
        );
    }
}
StudentList.contextType = StoreContext;
export default observer(withRouter(StudentList));
